module.exports = __webpack_public_path__ + "img/test-latest.0b891832.png";